import {NgModule} from '@angular/core';
import {AwardsAndAccreditationsComponent} from './awards-and-accreditations.component';

@NgModule({
    declarations: [AwardsAndAccreditationsComponent],
    exports: [AwardsAndAccreditationsComponent]
})
export class AwardsAndAccreditationsModule {
}
